import { defineStore } from 'pinia'
import { ref } from 'vue'
import useNotifications from '../composables/data/useNotifications'
import { makeGetCacheDataByNameWithUpdatableVersions } from '@/helpers/makeGetCacheDataByName'
import { ModulesMap } from '@/config/data/modulesMaps'

export const useCompanyNotificationStore = defineStore('companyNotification', () => {
	const companyNotificationsCount = ref(0)
	const notificationInterval = ref(null)


	const { getNotificationsUnreadCount } = useNotifications()

	let cacheNameGetter = makeGetCacheDataByNameWithUpdatableVersions()
	async function getUnreadCountNotifications() {

		if (cacheNameGetter.then) {
			cacheNameGetter = await cacheNameGetter
		}

		await cacheNameGetter.updateVersions()

		getNotificationsUnreadCount(
			{__ao__dateRange:'lastThirtyDays'},
			cacheNameGetter.getCacheDataByName(ModulesMap.NOTIFICATIONS)
		).then((res) => {
			companyNotificationsCount.value = res.count
		})
		return companyNotificationsCount.value
	}
	async function subscribeToNotifications() {
		getUnreadCountNotifications()
		notificationInterval.value = setInterval(() => {
			getUnreadCountNotifications()
		}, 120000)
	}
	function unsubscribeToNotifications() {
		clearInterval(notificationInterval.value)
	}
	function $reset() {
    companyNotificationsCount.value = 0
  }
	return {
		companyNotificationsCount,
		getUnreadCountNotifications,
		subscribeToNotifications,
		unsubscribeToNotifications,
		reset: $reset
	}
})
